import AppModal from "@/components/AppModal";
import RpIcon from "@/components/RpIcon";
import API from "@/constant/API";
import RouteConstant from "@/constant/RouteConstant";
import { VerifyAction } from "@/constant/VerifyConstant";
import useToggle from "@/hook/useToggle";
import {getTaskId, getUserInfo, setTaskRuleParams} from "@/redux/slices/user";
import axiosInstance from "@/utils/axios";
import { Box, Stack, Switch } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Security2FA from "./Security2FA";
import classes from "@/pages/security/css/index.module.less";
import {useTranslation} from "react-i18next";
import {enqueueSnackbar} from "notistack";
import SimpleHeader from "../components/Headers/SimpleHeader";
import {useTheme} from "@mui/material/styles";
import { useConfirm } from "material-ui-confirm";
import { isUserCompleteGuide } from "@/utils/userUtils";
import { StyledSwitch } from "@/styles/CommonStyledComponents";
import {dispatch} from "@/redux/store";
import { init2FAVerify } from '@/services/user/security';
import { getDeviceId } from '@/utils/utils';

function SecurityMobile() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useSelector(state => state.user);
  const theme = useTheme();
  const confirm = useConfirm();
  const {
    toggle: show2FA,
    onToggle: onToggleShow2FA,
  } = useToggle(false);
  const [option, setOption] = useState(1); // 1 绑定解绑  2 修改

  const _onChange = async () => {
    if (user.mobileBindStatus != 1) {
      try {
        const res:any = await init2FAVerify({
          'action': VerifyAction.BIND_SMS,
          'deviceId': getDeviceId(),
        });
        if (res?.optionsFix.length== 0 && res?.options.length== 0) {//没有验证项直接跳转绑定页
          navigate(RouteConstant.USER_SECURITY_MOBILE_BIND);
          return;
        }else {
          _doChange();
          return;
        }
      } catch (error) {
        enqueueSnackbar(error.msg || t("request_exception"), { variant: 'error' })
        return;
      }
    }
    confirm({
      title: t('warning'),
      description: t('security_option_change_alert_prompt'),
      confirmationText: t('confirm'),
      cancellationText: t('cancel'),
    }).then(() => {
      _doChange();
    });
  }

  const _doChange = () => {
    setOption(1);
    setTaskRuleParams({
      action: user.mobileBindStatus == 1 ? VerifyAction.CLOSE_MOBILE : VerifyAction.BIND_SMS,
    });
    onToggleShow2FA();
  }

  const _bindSwitch = () => {
    return <Stack direction={'row'} alignItems="center" justifyContent="space-between" className={classes["security-switch-module"]}>
      <Stack direction={'column'}>
        <div className={classes['security-type']}>{t('mobile')}</div>
        <div className={classes['security-account']}>{user.mobile ?? ''}</div>
      </Stack>
      <StyledSwitch checked={user.mobileBindStatus==1?true:false} onClick={_onChange} />
    </Stack>
  }

  const _onChangeMobile = () => {
    if (!isUserCompleteGuide(user)) {
      _doChangeMobile();
      return;
    }

    confirm({
      title: t('warning'),
      description: t('security_option_change_alert_prompt'),
      confirmationText: t('confirm'),
      cancellationText: t('cancel'),
    }).then(() => {
      _doChangeMobile();
    });
  }

  const _doChangeMobile = () => {
    setOption(2);
    setTaskRuleParams({
      action: VerifyAction.UPDATE_SMS,
    })
    onToggleShow2FA();
  }

  const _on2FAAllPass = async () => {
    onToggleShow2FA()
    // 绑定或解绑
    if (option == 1) {
      // 解绑
      if (user.mobileBindStatus == 1) {
        await axiosInstance.post(API.MOBILE_UNBIND, {
          taskId: getTaskId(),
        });
        // TODO: toast 提示用户解绑成功
        enqueueSnackbar(t('successful'), { variant: 'success' })
        dispatch(getUserInfo());
        navigate(-1);
        return;
      } 
      // 绑定
      else {
        navigate(RouteConstant.USER_SECURITY_MOBILE_BIND);
      }
    } else {
      navigate(RouteConstant.USER_SECURITY_MOBILE_UPDATE);
    }
  }

  const _changeMobileLink = () => {
    return <Stack
      direction="row"
      alignItems='center'
      justifyContent="space-between"
      onClick={_onChangeMobile}
      className={classes["update-account-wrap"]}
    >
      <Stack
        direction="row"
        alignItems='center'
        gap={1}
      >
        <RpIcon icon="change-x-copy" size={22}/>
        <span>{t('change_mobile')}</span>
      </Stack>
      <RpIcon icon="arrow-right-simple" size={22}/>
    </Stack>
  }

  if (!user) return null;

  return (<>
    <SimpleHeader />
    <Box className={classes["security-wrap"]}>
      <Box className={classes["security-title-wrap"]}>
        <div className={classes["security-title"]}>{t('mobile')}</div>
        <div className={classes["security-subtitle"]}>{t('mobile_subtitle')}</div>
      </Box>
      <Box className={classes["security-img-wrap"]}>
        <img src={theme.palette.mode === 'dark' ? '/images/account/mobile-dark.svg' : '/images/account/mobile.svg'} alt=""/>
      </Box>
      <Box>
        {_bindSwitch()}
        {user.mobileBindStatus == 1 && _changeMobileLink()}
      </Box>
      <AppModal open={show2FA} onClose={onToggleShow2FA}>
        <Security2FA callback={_on2FAAllPass} onClose={onToggleShow2FA}/>
      </AppModal>
    </Box>
  </>);
}

export default SecurityMobile;
